import component from './zh-CN/component';
import globalHeader from './zh-CN/globalHeader';
import menu from './zh-CN/menu';
import pages from './zh-CN/pages';
import pwa from './zh-CN/pwa';
import settingDrawer from './zh-CN/settingDrawer';
import settings from './zh-CN/settings';

export default {
  'navBar.lang': '语言',
  'layout.user.link.help': '帮助',
  'menu.withdrawal': '提现记录',
  'menu.subscription': '矿机申购记录',
  'menu.refund': '申请退款',
  'layout.user.link.privacy': '隐私',
  'layout.user.link.terms': '条款',
  'app.preview.down.block': '下载此页面到本地项目',
  'app.welcome.link.fetch-blocks': '获取全部区块',
  'app.welcome.link.block-list': '基于 block 开发，快速构建标准页面',
  ...pages,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  'pages.withdrawRecord.updateForm.withdrawal.tgid': 'tgid',
  "pages.withdrawRecord.availableBalance": "剩余可提现金额",
  "pages.withdrawRecord.beforeBalance": "提现前金额",
  "pages.withdrawRecord.create_time": "申请时间",
  "pages.withdrawRecord.confirm_time": "审核时间",
  "pages.withdrawRecord.draw_num": "提现金额",
  "pages.withdrawRecord.draw_total": "总提现金额",
  "pages.withdrawRecord.u_machine_level": "矿机等级",
  "pages.withdrawRecord.open_num": "开石头次数",
  "pages.withdrawRecord.draw_count": "提现次数",
  "pages.withdrawRecord.free": "手续费",
  "pages.withdrawRecord.is_accelerate": "是否加速",
  "pages.withdrawRecord.status": "状态",
  "pages.withdrawRecord.rejected": "拒绝",
  "pages.withdrawRecord.confirm": "同意",
  "pages.withdrawRecord.u_username": "用户名",
  "pages.withdrawRecord.updateForm.withdrawal.avatar": "头像",
  "pages.withdrawRecord.destroy_machine": "已销毁矿机",
};
